import { Injectable, Injector } from '@angular/core';

import { WidgetType } from '@frontend/sports/types/components/widget';
import { OnAppInit } from '@frontend/vanilla/core';
import { WidgetRegistryService } from 'packages/sports/web/app/src/widget/core/widget-registry.service';

import { AffiliateHelperComponent } from './affiliate-helper.component';

@Injectable()
export class AffiliateWidgetRegistration implements OnAppInit {
    constructor(
        private widgetRegistry: WidgetRegistryService,
        private injector: Injector,
    ) {}

    onAppInit(): void {
        this.widgetRegistry.registerLazy(WidgetType.AffiliateHelper, AffiliateHelperComponent, this.injector);
    }
}
